import { supabase } from './supabase';

/**
 * ID de `usuarios` para RPCs que validan sesión.
 * Prioriza `get_usuario_id_from_auth` (auth_id + email); si falla, email como `current_usuario_id()` en BD legacy.
 */
export async function resolveUsuarioIdForRpc(): Promise<string> {
  const { data: fromRpc, error: rpcErr } = await supabase.rpc('get_usuario_id_from_auth');
  if (!rpcErr && fromRpc) {
    return String(fromRpc);
  }

  const {
    data: { user },
  } = await supabase.auth.getUser();
  if (!user?.email) {
    throw new Error('Usuario no identificado. Vuelve a iniciar sesión.');
  }

  const { data: byEmail } = await supabase
    .from('usuarios')
    .select('id')
    .ilike('email', user.email.trim())
    .maybeSingle();

  if (byEmail?.id) {
    return String(byEmail.id);
  }

  if (user.id) {
    const { data: byAuth } = await supabase
      .from('usuarios')
      .select('id')
      .eq('auth_id', user.id)
      .maybeSingle();
    if (byAuth?.id) return String(byAuth.id);
  }

  throw new Error('Usuario no identificado. Vuelve a iniciar sesión.');
}
